import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'

export const SOUND_EFFECT_TYPE = {
  ENTER: 'se-enter',
  PUT_PIECE: 'se-put-piece',
  SWAP: 'se-swap'
}

export const SoundContext = React.createContext()

export function SoundProvider(props) {
  const { children } = props
  
  const [open, _setOpen] = useState(false)
  const [isFirst, setIsFirst] = useState(true)
  const [isMounted, setIsMounted] = useState(false)
  const [enableEnterSE, _setEnableEnterSE] = useState(true)
  const [enablePutPieceSE, _setEnablePutPieceSE] = useState(true)
  const [enableSwapSE, _setEnableSwapSE] = useState(true)

  const play = (name, enable) => {
    if (
      enable === true ||
      ( name === SOUND_EFFECT_TYPE.ENTER && enableEnterSE ) ||
      ( name === SOUND_EFFECT_TYPE.PUT_PIECE && enablePutPieceSE ) ||
      ( name === SOUND_EFFECT_TYPE.SWAP && enableSwapSE )
    ) {
      document.getElementById(name).play().catch(error => console.dir(error))
    }
  }

  const setOpen = (value) => {
    if (value && isFirst) {
      setIsFirst(false)
    }
    _setOpen(value)
  }

  const firstOpen = () => {
    if (isFirst) {
      setOpen(true)
    }
  }

  const setEnableEnterSE = (enable) => {
    if (enable) {
      play(SOUND_EFFECT_TYPE.ENTER, enable)
    }
    _setEnableEnterSE(enable)
  }

  const setEnablePutPieceSE = (enable) => {
    if (enable) {
      play(SOUND_EFFECT_TYPE.PUT_PIECE, enable)
    }
    _setEnablePutPieceSE(enable)
  }

  const setEnableSwapSE = (enable) => {
    if (enable) {
      play(SOUND_EFFECT_TYPE.SWAP, enable)
    }
    _setEnableSwapSE(enable)
  }

  useEffect(() => {
    if (isMounted === false) {
      let userAgent = window.navigator.userAgent.toLowerCase()
      if ( userAgent.indexOf('iphone') > 0 || userAgent.indexOf('ipad') > 0 ) {
        _setEnableEnterSE(false)
        _setEnablePutPieceSE(false)
        _setEnableSwapSE(false)
      }
      setIsMounted(true)
    }
  }, [isMounted])

  return (
    <SoundContext.Provider
      value={{
        open,
        enableEnterSE,
        enablePutPieceSE,
        enableSwapSE,
        setOpen,
        firstOpen,
        play,
        setEnableEnterSE,
        setEnablePutPieceSE,
        setEnableSwapSE
      }}
    >
      <audio id={SOUND_EFFECT_TYPE.ENTER} src="/sound/enter.mp3"></audio>
      <audio id={SOUND_EFFECT_TYPE.PUT_PIECE} src="/sound/go-piece.mp3"></audio>
      <audio id={SOUND_EFFECT_TYPE.SWAP} src="/sound/go-take-out.mp3"></audio>
      {children}
    </SoundContext.Provider>
  )
}


// WEBPACK FOOTER //
// ./src/Parts/Sound/SoundProvider.js